import lodash from 'lodash'

import { request } from '../../../../1stlog-ui/src/utils'

export async function requestAdd(payload) {
  const url = '/api/addressbook'
  const { data } = await request({
    method: 'put',
    url,
    data: payload
  })
  return data
}

export async function requestUpdate(payload) {
  const { id } = payload
  const url = `/api/addressbook/${id}`
  const { data } = await request({
    method: 'patch',
    url,
    data: payload
  })
  return data
}

// export async function requestRemove(payload) {
//   const { data } = await request({
//     method: "post",
//     url: "/api/order/submit",
//     data: payload
//   })
//   // FIXME: backend error: order is created, but clientNotifications cause crash in StoreOrderService:418
//   return data
// }
